import React from 'react';
import { Layout, Typography, Tag, Space } from 'antd';
import { WifiOutlined } from '@ant-design/icons';

const { Header: AntHeader } = Layout;
const { Text } = Typography;

const Header = ({ peerId, peerConnected, username }) => {
  return (
    <AntHeader style={{ 
      background: '#538f32', 
      display: 'flex', 
      alignItems: 'center',
      justifyContent: 'space-between'
    }}>
      <div>
        <img
          src="/logo60.png"
          alt="Logo"
          style={{ height: 40, width: 40, marginRight: 12 }}
        />
        <Text strong style={{ color: 'white', fontSize: '18px' }}>
          DropFilez
        </Text>
      </div>
      
      <Space>
        <Tag icon={<WifiOutlined />} color="green">
          Local Network
        </Tag>
      </Space>
    </AntHeader>
  );
};

export default Header;